<template>
  <v-sheet class="bg-blue-grey pa-7" rounded>
    <v-card class="mx-auto px-6 py-8" max-width="344">

      <v-img :src="require(`@/assets/logo2.png`)" />
      <v-form v-model="form" @submit.prevent="onSubmit">
        <v-text-field v-model="email" :readonly="loading" :rules="[required]" class="mb-2" clearable
          label="Email"></v-text-field>

        <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Contraseña"
          counter @click:append="show1 = !show1"></v-text-field>

        <br>

        <v-btn @click="signIn()" :loading="loading" block color="$blue-grey-6" size="large" type="submit"
          variant="elevated">
          Iniciar sesión
        </v-btn>
        
        <br>
        <v-btn @click="registerForm()" :loading="loading" block color="$blue-grey-6" size="large" type="submit"
          variant="elevated">
          Registrarse
        </v-btn>
        <br>
        <v-btn href="/restCont" color=#6f98b4 >
          Restablecer contraseña
        </v-btn>
      </v-form>
    </v-card>
  </v-sheet>
</template>

<script>

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
export default {
  data: () => ({
    form: false,
    email: null,
    show1: false,
    show2: true,
    password: '',
    rules: {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => (`The email and password you entered don't match`),
    },
    loading: false,
  }),
  methods: {
    onSubmit() {
      if (!this.form) return
      this.loading = true
      setTimeout(() => (this.loading = false), 2000)
    },
    registerForm() {
      this.$router.push('/registry');
    },
    signIn() {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then(() => {
          //alert('Inicio de sesión correcto');
          this.$router.push('/account');
        })
        .catch(error => {
          alert(error.message);
        });
    },
    required(v) {
      return !!v || 'Field is required'
    },
  },
}
</script>
